export const yymmddformatDate = (date) => {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
export const formatDate_ = (date) => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}
export const getLastWeekDate = () => {
  const today = new Date();
  const lastWeek = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  return formatDate(lastWeek).split(" ")[0];
}
export const paramsformatDate = (date, separator = '/') => {
  if (typeof date == 'string') {
    date = new Date(date)
  }
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return year + separator + month + separator + day
}
export const formatDate = (date) => {
  if (typeof date == 'string') return date
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  const seconds = String(date.getSeconds()).padStart(2, '0')
  return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`
}
export const getLastMonthDate = () => {
  const today = new Date();
  const lastWeek = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);
  return formatDate(lastWeek).split(" ")[0];
}

export const getLastYearDate = () => {
  const today = new Date();
  const lastWeek = new Date(today.getTime() - 365 * 24 * 60 * 60 * 1000);
  return formatDate(lastWeek).split(" ")[0];
}
export function getNextDay(dateString) {
  const today = new Date(dateString);
  const tomorrow = new Date(today.getTime() + 24 * 60 * 60 * 1000); // 加上一天的毫秒数
  const year = tomorrow.getFullYear();
  const month = tomorrow.getMonth() + 1;
  const day = tomorrow.getDate();
  return `${year}/${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}`;
}
